export const getDeliveryMethodDescription = (methodId: string): string => {
  const descriptionMap = new Map();
  descriptionMap.set('flexible_shipping', 'Estimated within 3-5 working days');

  return descriptionMap.get(methodId) || '';
};
